<template>
<div id="ag-grid-demo">
    <vx-card>
        <ag-grid-vue :gridOptions="gridOptions"  class="ag-theme-material w-100  ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="contacts" :floatingFilter="true" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true">
        </ag-grid-vue>
        <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>
</div>
</template>

<script>
import {
    AgGridVue
} from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
export default {
    components: {
        AgGridVue
    },
    data() {
        return {

            gridOptions: {
                onFilterChanged: this.onGridReady,
                rowModelType: 'infinite',
                onRowDoubleClicked: this.navigate,
                rowSelection: "single",
                floatingFiltersHeight: 40,
                rowStyle: {
                    'text-align': 'center',
                    'cursor': 'pointer'
                },
            },
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: false,
                resizable: true,
                filter: true,
                suppressMenu: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true
                },
                filterParams: {
                    newRowsAction: 'keep',
                }
            },
            columnDefs: [{
                    headerName: 'DoctorId',
                    field: 'doctorId',
                    filter: true,
                    width: 163
                },
                {
                    headerName: 'Doctor',
                    field: 'doctor',
                    filter: true,
                    width: 294,
                    cellStyle: {
                        'text-align': 'left'
                    }
                },

                {
                    headerName: 'Clinic',
                    field: 'clinicName',
                    filter: true,
                    width: 294,
                    cellStyle: {
                        'text-align': 'left'
                    }
                },
                {
                    headerName: 'PhoneNo',
                    field: 'phoneNo',
                    filter: true,
                    width: 181
                },

                {
                    headerName: 'Address',
                    field: 'address',
                    filter: true,
                    width: 367,
                    cellStyle: {
                        'text-align': 'left'
                    }
                }

            ],
            contacts: [{}],

        }
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 8
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady()
            }
        }
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridApi.sizeColumnsToFit();
    },
    methods: {
        onGridReady(params) {
            this.gridApi.showLoadingOverlay()
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            var request = {
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.gridApi.getFilterModel()
            }
            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                            "admin/getDoctorDashboard",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": this.$session.get('adminToken'),
                                    "AdminUserID": this.$session.get('adminId')
                                }
                            })
                        .then(response => {
                            params.successCallback(response.data.data, response.data.recordsTotal);
                            this.gridApi.hideOverlay();
                        });
                }
            }
            this.gridApi.setDatasource(datasource);
        },
        navigate() {
            var selectedrow = this.gridApi.getSelectedRows();
            var selectedDoctorId = "";
            var selectedClinicId = "";
            selectedrow.forEach((value) => {
                selectedDoctorId = value.doctorId;
                selectedClinicId = value.clinicId;
            })
            this.$router.push({
                path: "doctorMaster",
                query: {
                    doctorId: selectedDoctorId,
                    clinicId: selectedClinicId
                }
            })
        }
    },

}
</script>

<style>
.ag-header-cell-label {
    justify-content: center;
}
</style>
